var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Menu',{attrs:{"mode":"horizontal","active-name":_vm.$route.name},on:{"on-select":_vm.selectMenu}},[_c('MenuItem',{attrs:{"name":"private_cloud_fast_create_server"}},[_vm._v("\n      快速创建实例\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }